import React from 'react';
import { Full } from '../../layout/Full/Full';
import { RelativeCenter } from '../../layout/RelativeCenter/RelativeCenter';
import { Loader } from '../Loader/Loader';
import { TColorRole } from '../../../types/types';

interface ILoaderFallbackProps {
    color: TColorRole;
    label: string;
}

export const LoaderFallback: React.FC<ILoaderFallbackProps> = ({ color, label }) => (
    <Full>
        <RelativeCenter>
            <Loader width={30} height={30} strokeWidth={8} color={color} label={label} />
        </RelativeCenter>
    </Full>
);
